import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Combines conditional class names and resolves conflicting Tailwind utilities. */
export function cn(...classLists: ClassValue[]): string {
    return twMerge(clsx(...classLists));
}
